import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import RadioOnSvg from './radionOn.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: () => void,
};

export const RadioOnIcon = (props: any) => <Icon component={RadioOnSvg} {...props} />;

export const RadioOnButton = ({ size = 'medium', iconSize = 16, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<RadioOnSvg width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
